export default __webpack_public_path__ + "static/media/nas_landscape.b1ee106b.png";